import { Toaster } from 'sonner';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import './index.css';
import './styles/warmth.css';
import { initializeTheme } from '@/hooks/useTheme';

// Apply saved theme BEFORE render to avoid flash of wrong theme
initializeTheme();
import App from './App';
import AdminApp from './AdminApp';

// Decide which app to mount based on hostname
const isAdminDomain = typeof window !== 'undefined' && window.location.hostname === 'mng.kejja.tech';
import { AuthProvider } from '@/hooks/useAuth';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,              // 30s — a sensible default for small-to-medium queries
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {isAdminDomain ? <AdminApp /> : <AuthProvider><App /></AuthProvider>}
      </BrowserRouter>
    </QueryClientProvider>
        <Toaster richColors position="top-center" />
    </StrictMode>,
);
// Register service worker for push + PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('SW register failed:', err);
    });
  });
}
